import axios from '../../../requesters/axios';
import _ from 'underscore';
// import cookie from 'react-cookie';
import Debug from 'debug';
import Swal from 'sweetalert2';

import { getUrlVars } from '../../../utils'
import { HEADER_ERROR, NO_AUTOCARE_SELECTED } from '../../../constants/messages';

// import { API_URL } from '../../../../erp/actions';
import {
  SUBMIT_CHECKOUT_SUCCESS,
  SUBMIT_CHECKOUT_FAILURE,
  ADD_APPOINTMENT_DATA_FAILURE,
  ADD_APPOINTMENT_DATA_SUCCESS,
} from './types';
import { apiErrorHandler } from '../../../errors'
import { SWITCH_CHECKOUT_ACTIVE_ITEM } from '../checkoutContent/types'

const debug = Debug('bubocar-api:clientRegistrationActions');

function _submitCheckoutForm(values, done) {
  // El parametro force=true implica, que si falla MDI por algo diferente a un 409 (slot de tiempo ocupado)
  //  continua con la ejecución normal del código.
  let path = '/checkout?force=true'
  const urlVars = getUrlVars()
  // TODO: Esto se usa??
  if (urlVars.hasOwnProperty('sale')) {
    path = path.concat(path.includes('?') ? '&' : '?', 'sale', '=', urlVars['sale'])
  }

  // TODO: SS-2134 Se esta enviar el advisorEmailHash establecido en configuration.js, lo cual es incorrecto, ya que por
  // parámetros URL (workshopEmailHash) se puede establecer el concesionario, y este tendría que tener un advisor por
  // defecto, esto debería hacerlo API.
  axios.post(path,
    {
      ...values,
    })
    .then(response => {
      done(null, response.data);
    })
    .catch(oops => {
      done(oops)
    });
}

function _uploadTechnicalCardPhoto(image, done) {
  const formData = new FormData();

  formData.append('userFile', image[0]);

  axios.post(`/store`,
    formData)
    .then((response) => {
      done(null, {
        ...response.data,
        fileUri: image[0].preview
      })
    })
    .catch((error) => {
      done(error);
    });
}

export function submitCheckoutForm(values, autocareEmailHash, cb) {
  return (dispatch) => {
      // TODO: Ver si crea la task con el autocareEmailHash pasado como workshopEmailHash
      _submitCheckoutForm(values, (creationError, createdData) => {
        if (creationError) {
          // Verificamos si la fecha y hora ya estan reservadas.
          if (creationError.response.status === 409) {
            // Retornamos a los datos de la cita.
            dispatch({
              type: SWITCH_CHECKOUT_ACTIVE_ITEM,
              payload: {
                content: 'appointment'
              }
            })
          } else {
            // Cualquier otro error lanzamos la acción de fallo.
            dispatch({
              type: SUBMIT_CHECKOUT_FAILURE,
              payload: {
                error: creationError
              }
            })
          }
          apiErrorHandler(creationError)
        } else {
          cb(createdData.budget.budgetId)
          dispatch({
            type: SUBMIT_CHECKOUT_SUCCESS,
            payload: {
              data: createdData,
            }
          })
        }
      })
  }
}

export function addAppointmentData(data) {
  return (dispatch) => {
    const { budgetId, appointmentData } = data;
    axios.post(`/budgets/${budgetId}/appointment`, {
      appointmentData
    })
      .then((response) => {
        dispatch({
          type: ADD_APPOINTMENT_DATA_SUCCESS,
          payload: {
            data: response.data
          }
        })
      })
      .catch((error) => {
        debug(`Error in addAppointmentData -> error: ${error}`);
        dispatch({
          type: ADD_APPOINTMENT_DATA_FAILURE,
          payload: {
            error
          }
        })

        apiErrorHandler(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/clientRegistration/actions.js